import find from 'lodash/find';
import { CheckoutState } from '../../state';
import { getSelectedDeliveryMethodsForDisplay } from '../deliveryMethod';
import { getShippingRates } from '../event/pureSelectors';

export const getCalculatedShippingFees = (state: CheckoutState) => {
    // TODO EB-243614 We should refactor this to use early return + a purely functional approach to compute the sum. Also, the find(shippingRates…) bunch can probably be refactored into a constant-time-lookup data structure

    const shippingRates = getShippingRates(state);

    // Update display order cost with MoD fee
    let shippingFee = 0;

    if (shippingRates) {
        const selectedDeliveryMethods =
            getSelectedDeliveryMethodsForDisplay(state);
        selectedDeliveryMethods.forEach((deliveryMethod) => {
            const shippingRate = find(
                shippingRates,
                ({ name }) => name === deliveryMethod,
            );

            if (shippingRate) {
                shippingFee += shippingRate.price.value;
            }
        });
    }

    return shippingFee;
};
